<script>
/**
 * radio组件，替换浏览器原生radio
 */
import sizeMixin from "../../../utils/sizeMixin";
export default {
  name: "SjRadio",
  mixins: [sizeMixin],
  props: {
    value: {},
    type: {
      validator(value) {
        return ["round", "button"].includes(value);
      },
      default: "round"
    },
    data: {
      type: Array
    },
    space: {
      type: Number,
      default: 10
    },
    vertical: {
      type: Boolean,
      default: false
    },
    allowNull: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: null
    };
  },
  render(h) {
    const { type, data, handleClick, space, size, border, vertical } = this;
    /**
     * 在button类型时填充选项至每个选项宽度一致
     */
    this.$nextTick(() => {
      if (type === "button") {
        let nodes = this.$el.querySelectorAll(`.radio-${type}`);
        if (!nodes.length) return;
        let maxWidth = Math.max(...Array.from(nodes).map(v => v.clientWidth));
        Array.prototype.forEach.call(nodes, node => {
          node.style.width = `${maxWidth}px`;
        });
      }
    });
    /**
     * 根据类型返回不同结构的radio
     */
    return (
      <div
        class={[
          "sj-radio-group",
          `radio-group-${type}`,
          { border, vertical: vertical && type === "round" }
        ]}
      >
        {data.map((item, index) => {
          const { name, value, disabled = this.disabled, renderName } = item;
          return [
            ...[
              index > 0 && type === "button" ? (
                <div class={["verticle-line", { border }]} />
              ) : null
            ],
            <div
              class={[
                "radio",
                {
                  checked: this.value === value,
                  disabled,
                  border
                },
                `radio-${type}`,
                `radio-${type}-${size}`
              ]}
              style={
                type !== "button" && index < data.length - 1
                  ? { marginRight: `${space}px` }
                  : null
              }
              onClick={() => {
                !disabled && handleClick(value);
              }}
            >
              {type === "round" ? (
                <div
                  class={[
                    "round-box",
                    `round-box-${type}`,
                    `round-box-${size}`
                  ]}
                >
                  <span class={["round", `round-${size}`]}>
                    {this.value === value ? (
                      <span class="round-center" />
                    ) : null}
                  </span>
                </div>
              ) : null}
              {renderName ? (
                renderName(h, item)
              ) : (
                <span class={["text", `text-${type}`, `text-${type}-${size}`]}>
                  {name}
                </span>
              )}
            </div>
          ];
        })}
      </div>
    );
  },
  methods: {
    handleClick(value) {
      let newVal = value;
      if (this.value !== value) {
        this.$emit("change", newVal);
        this.$emit("input", newVal);
      } else if (this.allowNull) {
        newVal = null;
        this.$emit("change", newVal);
        this.$emit("input", newVal);
      }
      this.$emit("select", newVal);
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">
@--radio-color: @color-available;
@--radio-checked-color: @color-highlight;
@--radio-text-size: 14px;

@--radio-group-button-border: 1px solid @color-productlight;
@--radio-group-button-radius: @base-border-radius;
@--radio-button-hover-color: @color-productlight;
@--radio-button-verticle-line-color: @color-productlight;
@--radio-button-no-border-verticle-line-color: @color-light;
@--radio-button-padding-large: 0 10px;
@--radio-button-padding-middle: 0 10px;
@--radio-button-padding-default: 0 8px;
@--radio-button-padding-small: 0 8px;
@--radio-button-padding-mini: 0 8px;

@--radio-round-color: @color-alert-success;
// @--radio-round-checked-color: #00d983;
@--radio-round-disabled-color: @color-gray-3;

@--radio-square-color: @color-normal;
@--radio-square-checked-color: @color-alert-success;
@--radio-square-disabled-checked-color: @color-gray-3;
@--radio-square-disabled-color: @color-light;

@--radio-round-background: @color-antibg;

.sj-radio-group {
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
  &.vertical {
    flex-direction: column;
    align-items: flex-start;
    .radio {
      padding-left: 0;
      padding-right: 0;
      margin-right: 0 !important;
    }
  }
  &.radio-group-button {
    justify-content: space-evenly;
    background: @color-gray-2;
    &.border {
      border-radius: @--radio-group-button-radius;
      border: @--radio-group-button-border;
      background: transparent;
    }
  }

  .radio {
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 8px;
    padding-right: 8px;
    .font_color("available");

    .text {
      font-size: @--radio-text-size;
      line-height: @--radio-text-size;
      vertical-align: middle;
    }

    /*button*/
    .text-button {
      z-index: 1;
    }
    &.radio-button {
      box-sizing: border-box;
      white-space: nowrap;
      position: relative;
      z-index: 1;
      .font_color("normal");
      & + .verticle-line {
        flex-shrink: 0;
        width: 1px;
        height: 16px;
        background-color: @--radio-button-no-border-verticle-line-color;
        &.border {
          background-color: @--radio-button-verticle-line-color;
        }
      }

      &:hover {
        .font_color("available");
      }
      &:hover.border {
        .font_color("highlight");
      }
      &:hover:after {
        content: "";
        position: absolute;
        height: 100%;
        top: 0;
        bottom: 0;
        z-index: 0;
        background: @color-productlight;
        transition: background 100ms ease-in-out;
      }
      &:first-child:hover:after {
        left: 0;
        width: calc(100% + 2px);
      }
      &:last-child:hover:after {
        right: 0;
        width: calc(100% + 2px);
      }
      &:not(:last-child):not(:first-child):hover:after {
        width: calc(100% + 4px);
      }
      &.border:hover:after {
        background-color: @color-gray-2;
      }
    }
    &.radio-button-middle {
      padding: @--radio-button-padding-middle;
      height: @middle-size;
      .text {
        .text("body");
      }
    }
    &.radio-button-small {
      .text {
        .text("caption");
      }
      padding: @--radio-button-padding-small;
      height: @small-size;
    }
    &.radio-button-default {
      .text {
        .text("caption");
      }
      height: @default-size;
      padding: @--radio-button-padding-default;
    }
    &.radio-button-large {
      .text {
        .text("body");
      }
      height: @large-size;
      padding: @--radio-button-padding-large;
    }
    &.radio-button-mini {
      .text {
        .text("caption");
      }
      height: @mini-size;
      padding: @--radio-button-padding-mini;
    }

    /*round*/
    .text-round {
      margin-left: 5px;
    }
    .text-round-small {
      .text("caption", @color-dark, "regular");
    }
    .text-round-default {
      .text("body", @color-dark, "regular");
    }
    .round-box {
      display: flex;
      align-items: center;
      justify-content: center;
      &.round-box-small {
        width: 16px;
        height: 16px;
      }
      &.round-box-default {
        height: 20px;
        width: 20px;
      }
    }
    &.radio-round {
      &.radio-round-default {
        height: @default-size;
      }
      &.radio-round-small {
        height: @small-size;
      }

      &:hover .round-box-round {
        background-color: @color-gray-3;
      }

      &.disabled {
        .round {
          border-color: @--radio-round-disabled-color !important;

          .round-center {
            background-color: @--radio-round-disabled-color;
          }
        }
        &:hover .round-box-round {
          background-color: @color-antibg;
        }
      }
      // &.checked {
      //   .round {
      //     border: 5px solid @--radio-round-checked-color;
      //   }
      // }
      .round {
        height: 16px;
        width: 16px;
        box-sizing: border-box;
        border-radius: 50%;
        background-color: transparent;
        border: 3px solid @--radio-round-color;
        display: flex;
        justify-content: center;
        align-items: center;

        .round-center {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: @--radio-round-color;
        }
      }
    }

    /*square*/
    &.radio-square {
      &.disabled {
        &.checked {
          .square {
            background: @--radio-square-disabled-checked-color;
          }
        }
        .square {
          border-color: @--radio-square-disabled-color !important;
        }
      }
      &.checked {
        .square {
          border: none;
          background: @--radio-square-checked-color;
        }
      }
      .square {
        box-sizing: border-box;
        margin-right: 5px;
        width: 16px;
        height: 16px;
        background-color: transparent;
        border-radius: 2px;
        border: 1px solid @--radio-square-color;
        display: flex;
        justify-content: center;
        align-items: center;
        .check-icon {
          transform: scale(0.5);
          i {
            color: #fff;
            font-size: 12px;
          }
        }
      }
    }

    /*checked*/
    &.checked {
      .font_color("available");
      &.border {
        &.radio-button {
          .font_color("highlight");
        }
      }
    }

    /*disabled*/
    &.disabled {
      cursor: not-allowed;
      .font_color("light");
      .text-round,
      &:hover,
      &.border:hover {
        .font_color("light");
      }
      &:hover:after,
      &.border:hover:after {
        background: transparent;
      }
    }
  }
}
</style>
